import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Card } from "react-bootstrap";
import { adminGet,adminPost } from "../../../Services";
import districtData from "../../../assets/districts.json";
import {toast} from "react-toastify";

const ApplyDesignationModal = ({ memberId, show, onHide, onSuccess }) => {
  const states = [
    "Andaman and Nicobar",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chandigarh",
    "Chhattisgarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Ladakh",
    "Lakshadweep",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Puducherry",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];
  const [scope, setScope] = useState("");
  const [designations, setDesignations] = useState([]);
  const [loading, setLoading] = useState(false);

  // cascade data
  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [block, setBlock] = useState("");

  const [districts, setDistricts] = useState([]);
  const [blocks, setBlocks] = useState([]);

  useEffect(() => {
    if (show) {
      // reset all fields when modal opens
      setScope("");
      setState("");
      setDistrict("");
      setBlock("");
      setDistricts([]);
      setBlocks([]);
      setDesignations([]);
    }
  }, [show]);

  // clear designations whenever scope changes
  useEffect(() => {
    setDesignations([]);
  }, [scope]);

  // fetch designations when scope or location changes
  useEffect(() => {
    if (!scope) return;

    let query = "";
    if (scope === "National") {
      query = "?scope=National";
    } else if (scope === "State" && state) {
      query = `?scope=State&state=${encodeURIComponent(state)}`;
    } else if (scope === "District" && district) {
      query = `?scope=District&district=${encodeURIComponent(district)}`;
    } else if (scope === "Block" && block) {
      query = `?scope=Block&block=${encodeURIComponent(block)}`;
    } else return;

    setLoading(true);
    adminGet(`/api/designation-assignments/status${query}`)
      .then((res) => {
        setDesignations(res.data);
      })
      .catch((err) => {
        toast.error("Failed to fetch designations.");
        console.error("Error fetching designations", err);
      })
      .finally(() => setLoading(false));
  }, [scope, state, district, block]);

  // Handle state change → update districts
  const handleStateChange = (e) => {
    const selectedState = e.target.value;
    setState(selectedState);
    const filteredDistricts = districtData.districts.filter(
      (d) => d.state === selectedState
    );
    setDistricts(filteredDistricts);
    setBlocks([]);
  };

  // Handle district change → load blocks JSON dynamically
  const handleDistrictChange = async (e) => {
    const selectedDistrict = e.target.value;
    setDistrict(selectedDistrict);
    try {
      // Dynamically import the JSON file for blocks
      const blocksFile = await import(
        `../../../assets/BlocksList/${state.replace(/\s/g, "")}.json`
      );

      const districtBlocks = blocksFile[selectedDistrict] || [];
      setBlocks(districtBlocks);
    } catch (error) {
      console.error("Block list not found for this state:", error);
      setBlocks([]);
    }
  };

  const handleAssign = async (designationId) => {
    let payload = {
      memberId,
      designationId,
      scope,
    };

    if (scope === "State") {
      payload.state = state;
    } else if (scope === "District") {
      payload.state = state;
      payload.district = district;
    } else if (scope === "Block") {
      payload.state = state;
      payload.district = district;
      payload.block = block;
    }

    const request = adminPost("/api/designation-assignments/assign", payload);

    toast.promise(request, {
      pending: "Assigning designation...",
      success: "Designation assigned successfully.",
      error: {
        render({ data }) {
          return (
            data?.response?.data?.error || "Unable to assign designation."
          );
        },
      },
    });

    try {
      await request;
      if (onSuccess) onSuccess();
      onHide();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Apply for Designation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Step 1: Scope selection */}
        <Form.Group className="mb-3">
          <Form.Label>Select Scope</Form.Label>
          <Form.Select value={scope} onChange={(e) => setScope(e.target.value)}>
            <option value="">-- Select Scope --</option>
            <option value="National">National</option>
            <option value="State">State</option>
            <option value="District">District</option>
            <option value="Block">Block</option>
          </Form.Select>
        </Form.Group>

        {/* Step 2: Conditional cascading selects */}
        {scope === "State" && (
          <Form.Group className="mb-3">
            <Form.Label>Select State</Form.Label>
            <Form.Select
              name="state"
              value={state}
              onChange={handleStateChange}
            >
              <option value="">-- Select State --</option>
              {states.map((s, idx) => (
                <option key={idx} value={s}>
                  {s}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        )}

        {scope === "District" && (
          <>
            <Form.Group className="mb-3">
              <Form.Label>Select State</Form.Label>
              <Form.Select
                name="state"
                value={state}
                onChange={handleStateChange}
              >
                <option value="">-- Select State --</option>
                {states.map((s, idx) => (
                  <option key={idx} value={s}>
                    {s}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Select District</Form.Label>
              <Form.Select
                className="top-margin-sm"
                name="district"
                value={district}
                onChange={handleDistrictChange}
              >
                <option value="">-- Select District --</option>
                {districts.map((d, idx) => (
                  <option key={idx} value={d.district}>
                    {d.district}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </>
        )}

        {scope === "Block" && (
          <>
            <Form.Group className="mb-3">
              <Form.Label>Select State</Form.Label>
              <Form.Select
                name="state"
                value={state}
                onChange={handleStateChange}
              >
                <option value="">-- Select State --</option>
                {states.map((s, idx) => (
                  <option key={idx} value={s}>
                    {s}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Select District</Form.Label>
              <Form.Select
                className="top-margin-sm"
                name="district"
                value={district}
                onChange={handleDistrictChange}
              >
                <option value="">-- Select District --</option>
                {districts.map((d, idx) => (
                  <option key={idx} value={d.district}>
                    {d.district}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Select Block</Form.Label>
              <Form.Select
                className="top-margin-sm"
                name="block"
                value={block}
                onChange={(e) => setBlock(e.target.value)}
              >
                <option value="">-- Select Block --</option>
                {blocks.map((b, idx) => (
                  <option key={idx} value={b}>
                    {b}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </>
        )}

        {/* Step 3: Show designations */}
        {loading ? (
          <p>Loading designations...</p>
        ) : (
          designations.length > 0 && (
            <Row>
              {designations.map((des) => (
                <Col md={6} key={des.designationId} className="mb-3">
                  <Card>
                    <Card.Body>
                      <Card.Title>{des.name}</Card.Title>
                      <Card.Text>
                        Slots: {des.currentCount}/{des.maxCount} <br />
                        Remaining: {des.remainingSlots}
                      </Card.Text>
                      <Button
                        variant="primary"
                        disabled={des.remainingSlots === 0}
                        onClick={() => handleAssign(des.designationId)}
                      >
                        Apply
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          )
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ApplyDesignationModal;
